import React from 'react'

const HeaderRight = () =>
{
    return (
        <div className="headerUp__right">
            <h1 className="header-right--heading"><span
                className="italic_bold">POWERFUL SIMPLE</span><span
                    className="normal"> WITH A </span> <br /> <span
                        className="italic_bold"> SQUEEKY CLEAN</span> <span
                            className="normal"> DESIGN</span></h1>

            <h3 className="sub_heading">Find out how you can offer quick and
                                                                powerful solutions to your customers now!</h3><br />

            <button className="btn_leanmore"> LEARN MORE </button>
        </div>
    )
}

export default HeaderRight